import { OrganizationProfile } from '@borg/types';

class OrganizationRepository extends Repository<OrganizationProfile> {
  override get(id: string) {
    return this._get({
      url: () => `/organizations/${id}`,
      cache: 'always',
    });
  }
}

export const organizationRepository = new OrganizationRepository();
